import { Button } from '@acpaas-ui/react-components';
import React from 'react';
import { Link } from 'react-router-dom';
import { LOGIN_PATH } from '../../constants/paths.constants';

const AuthError = () => (
  <div className="u-text-center u-margin-top-xx">
    <h2 className="u-margin-bottom-lg">Login probleem</h2>
    <p className="u-margin-bottom">Er is een probleem opgetreden tijdens het inloggen.</p>
    <Link to={LOGIN_PATH}>
      <Button>Opnieuw inloggen</Button>
    </Link>
    <p className="u-margin-top">Als dit blijft voorkomen, heeft u waarschijnlijk geen MProfiel voor deze omgeving.</p>
  </div>
);

export default AuthError;
